// LoadingSpinner.jsx
import React from "react";

const LoadingSpinner = ({
  size = 32,
  text,
  fullscreen = false,
  className = "",
}) => {
  const Wrapper = ({ children }) =>
    fullscreen ? (
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center 
                    bg-white/60 dark:bg-black/40 backdrop-blur-sm ${className}`}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        {children}
      </div>
    ) : (
      <div
        className={`flex items-center justify-center p-4 ${className}`}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        {children}
      </div>
    );

  return (
    <Wrapper>
      <div className="flex flex-col items-center gap-2">
        <div
          className="animate-spin motion-reduce:animate-none rounded-full border-4 
                     border-neutral-300 dark:border-neutral-700 border-t-transparent"
          style={{ width: size, height: size }}
          aria-hidden="true"
        />
        <span
          className={
            text ? "text-sm text-neutral-600 dark:text-neutral-300" : "sr-only"
          }
        >
          {text || "Loading…"}
        </span>
      </div>
    </Wrapper>
  );
};

export default LoadingSpinner;
